module.exports = __webpack_public_path__ + "assets/img/thumb-Chama-Landing-Page-+-Website.881375ae.webp";